'use client';

import a__default from "react";
import { classNames } from "../../utils/styles/classNames.js";
import { option } from "./Select.css.js";
function FakeOption({ children }) {
  return /* @__PURE__ */ a__default.createElement("li", { "aria-selected": "false", className: classNames(option), role: "option" }, children);
}
export {
  FakeOption
};
